// extracted by mini-css-extract-plugin
export default {"form":"styles_form__xAKqP","input":"styles_input__l-0bk"};